import { render, staticRenderFns } from "./Luckdraw.vue?vue&type=template&id=4caba714&scoped=true"
import script from "./Luckdraw.vue?vue&type=script&lang=js"
export * from "./Luckdraw.vue?vue&type=script&lang=js"
import style0 from "./Luckdraw.vue?vue&type=style&index=0&id=4caba714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4caba714",
  null
  
)

export default component.exports